<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m15.6 12-5-4.9-1 1.1 3 3H2v1.6h10.6l-3 3 1 1zm-9-8.5A10 10 0 0 1 12 2a10 10 0 0 1 7 3 10 10 0 0 1 3 7 10 10 0 0 1-3 7 10 10 0 0 1-12.4 1.5l1.2-1.1a8 8 0 0 0 4 1q3.7 0 6.1-2.4a8 8 0 0 0 2.5-6 8 8 0 0 0-2.5-6A9 9 0 0 0 7.7 4.6z"
    />
  </svg>
</template>
